type ApiErrorLike = {
  message?: unknown;
  response?: {
    data?: {
      message?: unknown;
    };
  };
};

export const getApiErrorMessage = (
  error: unknown,
  fallbackMessage: string
) => {
  const apiError = error as ApiErrorLike;
  const responseMessage = apiError?.response?.data?.message;

  if (Array.isArray(responseMessage)) {
    const messages = responseMessage.filter(
      (message): message is string => typeof message === "string"
    );
    if (messages.length) return messages.join(". ");
  }

  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return responseMessage;
  }

  if (typeof apiError?.message === "string" && apiError.message.trim()) {
    return apiError.message;
  }

  return fallbackMessage;
};
